import * as allIcons from '@sloyd/icons';
import React from 'react';
import { Wrapper } from './Empty.style';

export type EmptyProps = {
  children?: React.ReactNode;
  iconName?: string;
};

export function Empty(props: EmptyProps) {
  const { iconName = 'IconList' } = props;

  const Cmp = (allIcons as any)[iconName] || allIcons.IconList;

  return (
    <Wrapper className='Empty-wrapper' data-testid='Empty-wrapper'>
      {Cmp && <Cmp size={60} />}
      {props.children}
    </Wrapper>
  );
}

export default Empty;
